export const styleRow = `
    width:60%;
    @media(max-width:1024px){
        width:80%;
    }
    @media(max-width:767px){
        width:100%;
    }
`
